;(() => {
  new Swiper('nav.blogs-index-nav .swiper', {
    autoHeight: true,
    grabCursor: true,
    slidesPerView: 'auto',
    freeMode: true
  })

  new Swiper('section.links-pills .swiper', {
    autoHeight: true,
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: true,
    spaceBetween: 15
  })

  document
    .querySelectorAll('section.featured-products .swiper')
    .forEach((section) => {
      new Swiper(section, {
        autoHeight: true,
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
          nextEl: section
            .closest('section')
            .querySelector('.swiper-button-next.featured-products'),
          prevEl: section
            .closest('section')
            .querySelector('.swiper-button-prev.featured-products')
        },
        scrollbar: {
          el: section.querySelector('.swiper-scrollbar.featured-products')
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            freeMode: false,
            spaceBetween: 30
          }
        }
      })
    })

  document
    .querySelectorAll('section.featured-collection .swiper')
    .forEach((section) => {
      new Swiper(section, {
        slidesPerView: 1,
        spaceBetween: 15,
        grabCursor: true,
        scrollbar: {
          el: section.querySelector('.swiper-scrollbar.featured-collection')
        },
        on: {
          init: function (instance) {
            setTimeout(() => {
              instance.update()
            }, 2000)
          }
        }
      })
    })

  const gallerySwiperThumbs = new Swiper(
    'article.blog .gallery .swiper-thumbs',
    {
      autoHeight: true,
      spaceBetween: 15,
      slidesPerView: 'auto'
    }
  )

  new Swiper('article.blog .gallery .swiper-main', {
    autoHeight: true,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next.gallery-next',
      prevEl: '.swiper-button-prev.gallery-prev'
    },
    thumbs: {
      swiper: gallerySwiperThumbs
    },
    spaceBetween: 15,
    slidesPerView: 1
  })

  new Swiper('section.banner .swiper.terms-mobile', {
    autoHeight: true,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: 500,
    autoplay: { delay: 3000 },
    slidesPerView: 1,
    a11y: {
      slideRole: 'link'
    }
  })

  new Swiper('nav.sub-collections .swiper', {
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: true,
    spaceBetween: 0
  })
})()

function getInitialSlide(container) {
  const selectedVariantId = container.getAttribute('data-initial-variant-id')

  const imageForVariant = document.querySelector(
    `figure.product-carousel .swiper-slide.variant-primary-image[data-variant-id="${selectedVariantId}"]`
  )

  if (imageForVariant) {
    const initialIndex = [...imageForVariant.parentNode.children].indexOf(
      imageForVariant
    )

    return initialIndex
  }
}

function initProductCarousel(containerElement, product) {
  const product_carousel = new Swiper(
    containerElement?.querySelector('.swiper-product'),
    {
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      initialSlide: getInitialSlide(containerElement),
      spaceBetween: 10,
      slidesPerView: 1,
      on: {
        slideChange: function () {
          //select relevant combination of options in the variant picker
          //it's important the click event is triggered on the input element here, and not the label
          //triggering click on the label will cause the page to scroll to the label as it gets focus on click
          const slideElement = this.slides[this.activeIndex]
          const variantId = Number(slideElement.getAttribute('data-variant-id'))

          if (slideElement.classList.contains('variant-primary-image')) {
            const relevantVariant = product.variants.find(
              (variant) => variant.id === variantId
            )

            relevantVariant?.options.forEach((option, index) => {
              containerElement
                .querySelector(
                  `label[data-option-${index + 1}="${handleize(option)}"] input`
                )
                ?.click()
            })
          }
        },
        init: function (swiper) {
          if (swiper.slides.length <= 1) {
            containerElement
              .querySelectorAll('.swiper-navigation')
              .forEach((element) => (element.hidden = true))
          }

          containerElement
            .querySelectorAll('.swiper-pagination, .swiper-navigation')
            .forEach((element) => (element.hidden = false))
        }
      },
      navigation: {
        nextEl: containerElement.querySelector('.swiper-button-next.product'),
        prevEl: containerElement.querySelector('.swiper-button-prev.product')
      },
      pagination: {
        el: containerElement.querySelector('.swiper-pagination.product'),
        dynamicBullets:
          containerElement.querySelectorAll('.swiper-slide').length >= 5,
        dynamicMainBullets: 3
      },
      breakpoints: {
        800: {
          slidesPerView: 1
        }
      }
    }
  )

  return product_carousel
}
